import MenuListItem from './menuListItem'
import BottomMenuListItem from './bottomMenuListItem'
import { Box, styled } from '@mui/system'
import { List } from '@mui/material'
import { ReactComponent as InfoIcon } from '@assets/sideMenuIcon/info.svg'
import { ReactComponent as UsersIcon } from '@assets/sideMenuIcon/users.svg'
import { ReactComponent as ProfileSetting } from '@assets/sideMenuIcon/profile_setting.svg'
import { MdPeopleAlt, MdOutlineTextsms } from 'react-icons/md'
import { hasPermission } from '@utils/permission_helper'
import { useContext } from 'react'
import { AuthContext } from '@contexts/Auth'
import { PermissionCodeEnum } from '@models/permission'

export interface SideMenu {
	id: string
	name: string
	icon: JSX.Element
	url?: string
	children?: SideMenu[]
	showMenu: boolean
}

const SidebarBox = styled(List)(() => ({
	backgroundColor: '#304A58',
	width: '300px',
	zIndex: '10',
	height: '100vh',
	paddingTop: '110px',
	paddingBottom: '0',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
}))

const BottomBox = styled(List)(() => ({
	backgroundColor: '#020F1D',
	height: '48px',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-evenly',
	alignItems: 'center',
	width: '100%',
}))

export default function Sidebar() {
	const { state: authState } = useContext(AuthContext)

	const sideMenuList: SideMenu[] = [
		{
			id: 'users',
			name: 'Users',
			icon: <UsersIcon fill="white" />,
			url: '/configurations/users_config/users',
			showMenu: hasPermission(authState?.userInfo, [
				PermissionCodeEnum.UserCreate,
				PermissionCodeEnum.UserRead,
				PermissionCodeEnum.UserUpdate,
				PermissionCodeEnum.UserDelete,
				PermissionCodeEnum.UserResetPassword,
				PermissionCodeEnum.UserAssignRole,
			]),
		},
		{
			id: 'userGroups',
			name: 'Projects & Roles',
			icon: <MdPeopleAlt style={{ fontSize: '32px', color: '#FFFFFF' }} />,
			url: '/configurations/users_config/user_groups/projects',
			showMenu: hasPermission(authState?.userInfo, [
				PermissionCodeEnum.RoleCreate,
				PermissionCodeEnum.RoleRead,
				PermissionCodeEnum.RoleUpdate,
				PermissionCodeEnum.RoleDelete,
				PermissionCodeEnum.RoleAssignUser,
			]),
		},
		// {
		// 	id: 'sms_recipients',
		// 	name: 'SMS Recipients',
		// 	icon: <MdOutlineTextsms style={{ fontSize: '32px', color: '#FFFFFF' }} />,
		// 	url: '/configurations/users_config/sms_recipients',
		// 	showMenu: true,
		// },
	]

	const bottomMenuList: SideMenu[] = [
		{
			id: 'profile-setting',
			name: 'Profile Setting',
			icon: <ProfileSetting fill="white" />,
			url: '/configurations/settings/profile-setting',
			showMenu: true,
		},
		{
			id: 'about',
			name: 'About',
			icon: <InfoIcon fill="white" />,
			url: '/configurations/about',
			showMenu: true,
		},
	]

	return (
		<Box component="nav">
			<SidebarBox>
				<Box>
					{sideMenuList.map((menuItem) => (
						<MenuListItem sideMenuItem={menuItem} key={menuItem.id + '_menuListItem'} />
					))}
				</Box>

				<BottomBox>
					{bottomMenuList.map((bottomMenuItem) => (
						<BottomMenuListItem
							sideMenuItem={bottomMenuItem}
							key={bottomMenuItem.id + '_bottomMenuListItem'}
						/>
					))}
				</BottomBox>
			</SidebarBox>
		</Box>
	)
}
